<template>
  <div id="culture" class="culture zy_constr">
    <div class="culture-title" v-if="!isMobile">企业文化</div>
    <img
      :src="cultrueBg"
      alt=""
      class="culture-img"
    />
    <div class="culture-title">掌阅范</div>
    <div class="culture-list">
      <div class="culture-item" v-for="item in CULTURE.list" :key="item.id">
        <img :src="item.icon" alt="" class="culture-item__icon" />
        <div class="culture-item__title">{{ item.name }}</div>
        <div class="culture-item__desc">
          <div class="culture-item__desc__item" v-for="desc in item.desc" :key="desc">{{ desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CULTURE } from '@/config';
import { isMobile } from '@/utils/utils'


export default {
  name: 'Culture',
  data() {
    return {
      CULTURE,
      isMobile: isMobile()
    };
  },
  computed: {
    cultrueBg() {
      return this.isMobile ? CULTURE.bg_wap : CULTURE.bg;
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.culture-title {
  font-size: 40px;
  line-height: 60px;
  color: #000;
  font-weight: 500;
  text-align: center;
  padding: 48px 0;
}

.culture-img {
  display: block;
  width: 100%;
}

.culture-list {
  display: flex;
}

.culture-item {
  width: 278px;
  height: 441px;
  margin-left: 16px;
  border-radius: 16px;
  background: #f8f8fa;
  padding-top: 36px;
  box-sizing: border-box;
  &:first-child {
    margin-left: 0;
  }
}

.culture-item__icon {
  display: block;
  width: 160px;
  height: 160px;
  margin: 0 auto;
}

.culture-item__title {
  font-size: 24px;
  line-height: 36px;
  margin-top: 24px;
  color: #000;
  font-weight: 500;
  text-align: center;
}

.culture-item__desc {
  margin-top: 24px;
  text-align: center;
  &__item {
    font-size: 14px;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.85);
  }
}
.S {
  .culture{
    padding: rem(72) rem(48);
  }
  .culture-title{
    font-size: rem(60);
    line-height: rem(78);
    padding: rem(72) 0;
  }
  .culture-list{
    flex-wrap: wrap;
  }
  .culture-item{
    width: rem(480);
    height: rem(224*3);
    margin-left: rem(24);
    margin-bottom: rem(24);
    padding-top: rem(48);
    &__title{
      font-size: rem(42);
      line-height: rem(54);
      margin-top: rem(36);
    }
    &__desc{  
      margin-top: rem(36);
      &__item{
        font-size: rem(36);
        line-height: rem(54);
      }
    }
    &__icon{
      width: rem(180);
      height: rem(180);
    }
    &:nth-child(2n+1){
      margin-left: 0;
    }
  }
}
</style>
